export const DATE_ONLY = "yyyy-MM-dd";
export const TIME_ONLY = "HH:mm";
export const DATE_TIME = `${DATE_ONLY} ${TIME_ONLY}`;
